import Vue from "vue";
import VueRouter from "vue-router";
import { default as routes, guestRoutes, authenticatedRoutes } from "./routes";
import { pageRoute } from "@utils/network";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: () => ({ x: 0, y: 0 }),
});

const guestRoutesNames = guestRoutes.map(route => route.name);
const authenticatedRoutesNames = authenticatedRoutes.map(route => route.name);


router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem("auth_token");    
    const isVisitingGuestRoute = guestRoutesNames.includes(to.name);
    const isVisitingAuthenticatedRoute = authenticatedRoutesNames.includes(to.name);
    
    if (isVisitingGuestRoute || isVisitingAuthenticatedRoute) {
        if (isVisitingGuestRoute && isAuthenticated) {
            // window.location = pageRoute("user/profile");
    
        } else if (isVisitingAuthenticatedRoute && !isAuthenticated) {
            const next = to.path[0] == "/" ? to.path.substr(1) : to.path;
            window.location = pageRoute("login", {}, true, {next});
        }
    }
    next();
})

export default router;
